const TrueCircleCheck = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2627_10084)">
        <circle cx="12" cy="12" r="12" fill="#7E50FF" />
        <path
          d="M10.8696 15.7928C10.4791 16.1834 9.84593 16.1834 9.45541 15.7928L6.42189 12.7593C6.12676 12.4642 6.12676 11.9857 6.42189 11.6906V11.6906C6.71701 11.3954 7.19551 11.3954 7.49064 11.6906L9.45541 13.6553C9.84593 14.0459 10.4791 14.0459 10.8696 13.6553L16.5094 8.01558C16.8045 7.72045 17.283 7.72045 17.5781 8.01558V8.01558C17.8733 8.3107 17.8733 8.7892 17.5781 9.08433L10.8696 15.7928Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2627_10084">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrueCircleCheck;
